var _defs, _path, _path2, _path3, _path4, _polygon, _path5, _path6, _path7, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDriver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 163 138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f2f2;stroke:#000;stroke-miterlimit:10;}.cls-2{fill:#009cdb;}.cls-3{fill:#fff;fill-rule:evenodd;}.cls-4{fill:#191919;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.23,136H16a5.18,5.18,0,0,1-5.18-5.18v-116A5.18,5.18,0,0,1,16,9.61H160.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.88,21l-32.19,4s-4.51,3.17-5.92,6.17a35.59,35.59,0,0,0-2.63,10.23v94.36l.91-.21h39.77Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M159.88,106H137a5,5,0,0,1-5-5l-2.45-27a5,5,0,0,1,5-5l25.32-.74"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.88,107.07H137a6,6,0,0,1-6-6L128.55,74a6,6,0,0,1,6-6l25.29-.74.06,2.07-25.32.74a3.94,3.94,0,0,0-4,3.89l2.45,27.1A3.94,3.94,0,0,0,137,105h22.88Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "124.61 95.37 124.61 133.3 132.03 133.3 132.03 114.72 124.61 95.37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132,134.33h-7.42a1,1,0,0,1-1-1V95.37a1,1,0,0,1,2-.37L133,114.35a1.16,1.16,0,0,1,.07.37V133.3A1,1,0,0,1,132,134.33Zm-6.38-2.07H131V114.91L125.65,101Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.17,135.74H118.1V41.38c0-12.23,8.73-17.11,9.1-17.31l.17-.09,32.53-4.06.25,2L128,26c-1.16.69-7.86,5.16-7.86,15.39Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M145.37,80.47c-4.71,0-9.49-1.5-9.49-4.37s4.78-4.36,9.49-4.36,9.5,1.5,9.5,4.36S150.09,80.47,145.37,80.47Zm0-6.66c-4.6,0-7.42,1.49-7.42,2.29s2.82,2.3,7.42,2.3,7.43-1.49,7.43-2.3S150,73.81,145.37,73.81Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 80,
    fill: "black",
    fontFamily: "OpenSans-Regular, Open Sans, sans-serif",
    fontSize: "9pt"
  }, "Driver")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default __webpack_public_path__ + "static/media/driver.75522118b7abdda1d4dce1a6a23e11ea.svg";
export { ForwardRef as ReactComponent };